// extracted by mini-css-extract-plugin
export var brand_logo = "styles-module--brand_logo--5c4ba";
export var copyright_container = "styles-module--copyright_container--245bc";
export var desc_btn_container = "styles-module--desc_btn_container--075db";
export var dropdown = "styles-module--dropdown--0cec4";
export var dropdown_arrow = "styles-module--dropdown_arrow--a3e5c";
export var dropdown_item_right = "styles-module--dropdown_item_right--41f48";
export var dropdown_item_right_desc = "styles-module--dropdown_item_right_desc--6e211";
export var dropdown_item_right_title = "styles-module--dropdown_item_right_title--cef6e";
export var footer = "styles-module--footer--9559f";
export var footer_container = "styles-module--footer_container--0409f";
export var header_right = "styles-module--header_right--5429f";
export var icon = "styles-module--icon--580fc";
export var iframe = "styles-module--iframe--57361";
export var is_active = "styles-module--is_active--c962d";
export var lang = "styles-module--lang--1229e";
export var line_new = "styles-module--line_new--da8e4";
export var line_new_nav = "styles-module--line_new_nav--28083";
export var link_list_title = "styles-module--link_list_title--ee926";
export var login_btn_menu_container = "styles-module--login_btn_menu_container--3ca80";
export var menu_btn = "styles-module--menu_btn--a190a";
export var mobile_dropdown_link = "styles-module--mobile_dropdown_link--40bd5";
export var nav_bar = "styles-module--nav_bar--c5f38";
export var nav_button = "styles-module--nav_button--61379";
export var new_dropdown_item = "styles-module--new_dropdown_item--c95ad";
export var new_en_footer = "styles-module--new_en_footer--93b45";
export var new_en_nav = "styles-module--new_en_nav--efc6e";
export var new_home_page_footer = "styles-module--new_home_page_footer--455cd";
export var new_home_page_nav = "styles-module--new_home_page_nav--798f3";
export var notta_logo = "styles-module--notta_logo--2a066";
export var open_width = "styles-module--open_width--d52f0";
export var security_desc = "styles-module--security_desc--33464";
export var security_switch_btn_container = "styles-module--security_switch_btn_container--8ba63";
export var switch_language_dropdown_container = "styles-module--switch_language_dropdown_container--dfea7";
export var tail = "styles-module--tail--23397";
export var title_decoration = "styles-module--title_decoration--9006a";
export var title_decoration_center = "styles-module--title_decoration_center--dc055";
export var title_decoration_right = "styles-module--title_decoration_right--f2b29";
export var title_text = "styles-module--title_text--b9cba";
export var title_text_mask = "styles-module--title_text_mask--5a8b1";
export var w_nav_menu = "styles-module--w_nav_menu--c00a0";
export var w_nav_overlay = "styles-module--w_nav_overlay--dffba";